import React, { useState, useEffect } from 'react'
import { Form, Button, Card, notification, Spin, Row, Col, Drawer, Popconfirm, Tooltip } from 'antd'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { listAllCountries } from '../../countries/actions/countries'
import { listQuickSearchUniversities } from '../../university/actions/university'
import { listAllCourse, loadCourseIntakesFxn } from '../../course/actions/courseAction'
import { addSelectedCourse } from '../../applications/actions/chooseStudent'
import { showPageLoad, hidePageLoad } from '../../../modules/actions'
import { listCourseCampus } from '../../campus/actions/campus'
import { fcmtUniversity, DirectUniversityCheck } from '../../../components/_utils/appUtils'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { EligibilityIcon } from '../../university/drawers/universityEligibility'
import { addPropertyManagementGrpFxn } from '../../../unizHome/actions'
import { TableComp } from 'sz-react-utils-lite'
import { ColumnWidth } from '../../WebComponent/columnWidth'
import { push } from 'connected-react-router'
import { getPropertyGrpFxn, getUnizHomePropertyListFxn } from '../action'

const AddPropertyManagementGroupDrawer = (props) => {
  const dispatch = useDispatch()
  const {
    form: { getFieldDecorator, setFieldsValue, getFieldValue, resetFields },
    onClose,
    onRefresh,
    visible

  } = props


  let inputTypes = {
    fields: [
      {
        key: 'property_group_name',
        label: 'Property management group',
        required: true,
        placeholder: 'Enter Property management group'
      }
    ]
  }


  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const handleSubmit = (e) => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        dispatch(showPageLoad())
        let data = await dispatch(addPropertyManagementGrpFxn(valData))
        if (data.success) {
          onClose()
          onRefresh()
        }
      } else {
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }

  const apiRequest = params => {
    return new Promise(async resolve => {

      let respData = await dispatch(
        getPropertyGrpFxn()
      )
      resolve({data:respData.data})
    })
  }

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      render: (val, record, index) => {
        return index + 1
      }
    },
    {
      title: 'Property Name',
      dataIndex: 'property_group_name',
      key: 'property_group_name',
      render: (val, record, index) => {
        return record
      }
    },

  ]
  return (
    <React.Fragment>
      <Drawer visible={visible}
              title={`Property Management Groups`}
              width={'50%'}
              closable={true}
              maskClosable={true}
              onClose={onClose}>
        <div className='card unizportal'>
          <div className='inner-form'>
            <Form onSubmit={handleSubmit} style={{ marginTop: 8, textAlign: 'left' }}>
              <Row gutter={24}>
                {inputTypes.fields.map((item, key) => {
                  return (
                    <Col span={item.span ? item.span : 24} md={item.span ? item.span : 24} sm={24} xs={24} key={key}>
                      <GetEachFormFields
                        item={item}
                        getFieldDecorator={getFieldDecorator}
                        formItemLayout={formItemLayout} />
                    </Col>
                  )
                })}
              </Row>

              <Form.Item>
                <button className='btn btn-default' type='submit'>Submit
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className='card'>
          <div >
            <h5>Property Group List </h5>
          </div>
            <TableComp
              columns={columns}
              apiRequest={apiRequest}
              pagination={{
                position: 'top',
                pageSizeOptions: ['20', '50', '75', '100'],
                defaultPageSize: 20
              }}
            />

        </div>
      </Drawer>
    </React.Fragment>
  )
}


export default Form.create()(AddPropertyManagementGroupDrawer)
